import { isToggleActiveDto } from '@interfaces/featureToggle';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/featureToggle';

export const isToggleActive = async (
  dto: isToggleActiveDto,
): Promise<{ success: boolean }> =>
  fetcher(`${API_URL}/isActive`, { method: 'POST', body: dto });
